import { FieldType, FilterFormDataModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { ASSET_TYPE, IMAGE_ART, PURSUE } from './vkb-form-fields';

export const vkbFilterFormData: FilterFormDataModel = {
  title: 'Asset',
  description: '',
  customClient: CustomClients.VKB,
  formFields: [
    {
      formTypeId: '1',
      formFieldName: 'pursue',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Unternehmen',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: PURSUE,
    },
    {
      formTypeId: '1',
      formFieldName: 'assetTypeCustom',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Datei-Art',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: ASSET_TYPE,
    },
    {
      formTypeId: '1',
      formFieldName: 'imageArt',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Bild-Art',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: IMAGE_ART,
    },
    {
      formTypeId: '4',
      formFieldName: 'status',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Status`,
      placeholder: $localize`:placeholder:-- All Status --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      sortDataSource: false,
      subProjectFlag: false,
      disable: false,
      visible: true,
      options: [],
    },
    {
      formTypeId: '13',
      formFieldName: 'date-label',
      fieldLabel: $localize`Date created`,
      fieldType: FieldType.Label,
      placeholder: '',
      visible: true,
      widthClass: WidthClass.WFull,
    },
    {
      formTypeId: '14',
      formFieldName: 'createdDate_from',
      fieldType: FieldType.Date,
      fieldLabel: $localize`From`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '15',
      formFieldName: 'createdDate_to',
      fieldType: FieldType.Date,
      fieldLabel: $localize`To`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '16',
      formFieldName: 'expiry-label',
      fieldLabel: $localize`Expiry date`,
      fieldType: FieldType.Label,
      placeholder: '',
      visible: true,
      widthClass: WidthClass.WFull,
    },
    {
      formTypeId: '17',
      formFieldName: 'expiryDate_from',
      fieldType: FieldType.Date,
      fieldLabel: $localize`From`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '18',
      formFieldName: 'expiryDate_to',
      fieldType: FieldType.Date,
      fieldLabel: $localize`To`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '18',
      formFieldName: 'expiryDate',
      fieldType: FieldType.Date,
      fieldLabel: $localize`Expiry date`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: false, // used only for filter bubbles, not visible in the form
    },
  ],
};
